import { $apiV2 } from '../../config/api';

export const fetchAffiliateMe = () => $apiV2.get('/affiliate/me');
export const fetchAffiliateReport = () => $apiV2.get('/affiliate/report');
